var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("캐시 result: "+_vm._s(_vm.data))])}
var staticRenderFns = []

export { render, staticRenderFns }